<template>
    <!-- 右侧主体内容  -->
    <el-main>
    <!-- 路由占位符 -->
    <router-view @close='CloseWxbindVisible'></router-view>
    </el-main>
</template>

<script>
export default {
  data() {
      return {
          wxbindVisible: false
      }
  },
  methods: {
    // 与微信相关，现不支持
       CloseWxbindVisible () {
          this.wxbindVisible = false
       }
  }
}
</script>

<style lang="less" scoped>
.el-main {
  background-color: #EAEDF1;
}
</style>
